module.exports = __webpack_public_path__ + "assets/img/19-59.e0b43601.svg";